import ChevronDownIcon from "@assets/images/vector-down.svg";
import {
  Box,
  InputAdornment,
  InputProps,
  makeStyles,
  MenuItem,
  TextField
} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
// import MenuItem from "@material-ui/core/MenuItem";
import Select, { SelectProps } from "@material-ui/core/Select";
import AddIcon from "@material-ui/icons/Add";
import CircleIcon from "@material-ui/icons/Brightness1";
import CloseIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import { mapVariantToColor } from "@saleor/changeOrder/utils";
import Checkbox from "@saleor/components/Checkbox";
import MyTypography from "@saleor/components/MyTypography";
// import { commonMessages } from "@saleor/intl";
import classNames from "classnames";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useIntl } from "react-intl";

export interface ISelectFieldProps {
  testId?: string;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  hint?: string | React.ReactNode;
  label?: string | React.ReactNode;
  name?: string;
  selectProps?: SelectProps;
  placeholder?: string;
  required?: boolean;
  InputProps?: InputProps;
  showChipDeleteButton?: boolean;
  listItemClass?: any;
  id?: string;
  onChange(value: any);
}
const useStyles = makeStyles(
  theme => ({
    root: {
      width: "100%",
      "& .MuiList-root .MuiListItem-root.Mui-selected": {
        background: "transparent !important"
      }
    },
    indeterminateColor: {
      color: theme.palette.info.main
    },
    selectAllText: {
      fontWeight: 500,
      marginLeft: theme.spacing(1)
    },
    selectedAll: {
      background: "#F4F7FE !important",
      height: 48,

      "&:hover": {
        background: "#EBF1FF !important"
      },
      "& .MuiTypography-root": {
        color: theme.palette.info.main
      }
    },
    closeIcon: {
      width: 14,
      color: "#007E92"
    },
    addIcon: {
      width: 16,
      color: "rgba(0, 0, 0, 0.6)",
      marginRight: -10,
      opacity: 0
    },
    muiChip: {
      fontSize: "14px",
      borderRadius: ".25rem",
      height: 25,
      background: "#F2FAFB",
      color: "#007E92",
      maxWidth: "100%"
    },
    muiOutlineWithItem: {
      padding: "8px 32px 9px 10px"
    },
    muiMenuItem: {
      height: 48,
      cursor: "pointer",

      "&:hover": {
        background: "#F4F7FE !important",
        "& .MuiTypography-root": {
          color: theme.palette.info.main
        }
      },

      "&.Mui-selected": {
        background: "#F4F7FE !important",
        "&:hover": {
          background: "#EBF1FF !important"
        },
        "&:focus": {
          background: "#F4F7FE !important"
        },
        "& .MuiTypography-root": {
          color: theme.palette.info.main
        }
      }
    },
    placeholder: {
      color: "rgba(0, 0, 0, 0.54)",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    noBorder: {
      border: "none"
    },
    textField: {
      borderBottom: `1px solid ${theme.palette.grey["300"]}`,
      position: "sticky",
      top: 0,
      background: "white",
      zIndex: 10
    },
    muiChipFirst: {
      maxWidth: "100%"
    },
    checkbox: {
      marginLeft: 0,
      marginRight: 0
    },
    chipWrapper: {
      display: "flex",
      width: "100%",
      overflow: "hidden"
    },
    circleIcon: {
      width: "12px",
      margin: theme.spacing(0, 1, 0, 1)
    },
    spacer: {
      marginLeft: "0.8rem"
    }
  }),
  { name: "MultipleSelect" }
);

const MenuProps = {
  PaperProps: {
    style: {
      // maxHeight: 240,
      borderRadius: "0 0 6px 6px",
      marginTop: "0.5rem"
    }
  },
  autoFocus: false,
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  MenuListProps: {
    class: "select",
    style: {
      paddingLeft: "0px"
    }
  }
};

enum SelectValueEnum {
  ALL = "all",
  SEARCH = "search"
}
export interface IChoice {
  label: string;
  value: string;
  color?: string;
}
interface IMultiSelectFieldProps extends ISelectFieldProps {
  selectAllLabel?: string;
  value?: string[];
  enableSearch?: boolean;
  choices: IChoice[];
  isReset?: boolean;
  numberItemDisplay?: number;
  showCircularIcon?: boolean;
  isClean?: boolean;
  disableIndeterminate?: boolean;
  ignoreRerender?: boolean;
}

const OrderStatusCustom: React.FC<IMultiSelectFieldProps> = props => {
  const {
    disabled,
    label,
    selectAllLabel = "All",
    choices = [],
    value = [],
    onChange,
    name,
    required,
    placeholder,
    selectProps,
    enableSearch,
    error,
    isReset,
    numberItemDisplay = 1,
    showChipDeleteButton = true,
    showCircularIcon = true,
    isClean,
    listItemClass,
    disableIndeterminate,
    ignoreRerender = false,
    id,
    testId
  } = props;

  const classes = useStyles();
  const intl = useIntl();

  const [selected, setSelected] = useState(value);
  const [choicesList, setChoicesList] = useState(choices);
  const firstRender = useRef(true);
  const IconSelectCustom = props => (
    <img
      {...props}
      src={ChevronDownIcon}
      alt=""
      className={classNames(`material-icons ${props.className}`)}
    />
  );
  const computeAllSelected = selected =>
    choicesList.length > 0 && selected.length === choices.length;

  const isAllSelected = useMemo(() => computeAllSelected(selected), [selected]);

  const handleChange = event => {
    const values = event.target.value;

    if (values[values.length - 1] !== SelectValueEnum.SEARCH) {
      const choicesValue = choicesList.map(choice => choice.value);
      if (values[values.length - 1] === SelectValueEnum.ALL) {
        setSelected(selected.length === choicesList.length ? [] : choicesValue);
      } else {
        setSelected(values);
      }
    }
  };

  useEffect(() => {
    setSelected(value);
  }, [value]);

  useEffect(() => {
    if (isClean) {
      setSelected(value || []);
    }
  }, [isClean]);

  const handleDelete = (e: React.MouseEvent, value: string) => {
    e.preventDefault();

    if (value === SelectValueEnum.ALL) {
      setSelected([]);
    } else {
      const selectedFilter = selected.filter(
        selectValue => selectValue !== value
      );
      setSelected(selectedFilter);
    }
  };

  const onSearch = event => {
    const value = event.target.value;

    const choicesFilter = choices.filter(
      choice =>
        choice.value.toLowerCase().includes(value.toLowerCase()) ||
        choice.label.toLowerCase().includes(value.toLowerCase())
    );

    setChoicesList(choicesFilter);
  };

  // const isHasChoice = useMemo(() => Boolean(choices.length), [choices]);

  useEffect(() => {
    // if (choices.length) {
    if ((firstRender.current && choices.length) || ignoreRerender) {
      setChoicesList(choices);
      firstRender.current = false;
    }

    //   if (value.length) {
    //     setSelected(value);
    //   } else {
    //     setSelected(choices.map(choice => choice.value));
    //   }
    // } else {
    //   setChoicesList([]);
    // }
  }, [choices, firstRender]);

  useEffect(() => {
    if (isReset) {
      setSelected([]);
    }
  }, [isReset]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange({
        target: {
          name,
          value: selected
        }
      });
    });

    return () => {
      clearTimeout(timeout);
    };
  }, [selected]);

  const getSelectedLabel = (value: string) =>
    choices.find(choice => choice.value === value)?.label;

  const mapSelectedToColor = (value: string, isBgrColor: boolean) => {
    const item = choices.find(choice => choice.value === value);

    return mapVariantToColor(item?.color, isBgrColor);
  };

  const renderChips = (selected: string[]) => {
    if (selected.length !== choices.length) {
      return (
        <div className={classes.chipWrapper}>
          {selected.slice(0, numberItemDisplay).map(item => (
            <Box mr={1} className={classNames(classes.muiChipFirst)} key={item}>
              <Chip
                style={mapSelectedToColor(item, true)}
                classes={{ root: classes.muiChip }}
                label={getSelectedLabel(item)}
                clickable
                deleteIcon={
                  showChipDeleteButton ? (
                    <CloseIcon
                      style={mapSelectedToColor(item, false)}
                      onMouseDown={event => event.stopPropagation()}
                      className={classes.closeIcon}
                    />
                  ) : (
                    <></>
                  )
                }
                onDelete={e => handleDelete(e, item)}
              />
            </Box>
          ))}
          {selected.length > numberItemDisplay ? (
            <Chip
              classes={{ root: classes.muiChip }}
              key={selected.length}
              label={selected.length - numberItemDisplay}
              icon={<AddIcon className={classes.addIcon} />}
            />
          ) : (
            <></>
          )}
        </div>
      );
    }
    return (
      <Chip
        classes={{ root: classes.muiChip }}
        label={selectAllLabel}
        clickable
        deleteIcon={
          <CloseIcon
            onMouseDown={event => event.stopPropagation()}
            className={classes.closeIcon}
          />
        }
        onDelete={e => handleDelete(e, SelectValueEnum.ALL)}
      />
    );
  };

  const renderPlaceholder = () => (
    <MyTypography variant="body3" className={classes.placeholder}>
      {placeholder}
    </MyTypography>
  );

  return (
    <FormControl className={classes.root} error={error}>
      <label className="text-xs font-semibold text-color-base pb-1">
        {label} {required ? <span className="text-primary">*</span> : ""}
      </label>
      <Select
        classes={{
          outlined: selected.length ? classes.muiOutlineWithItem : ""
        }}
        variant="outlined"
        labelId="mutiple-select-label"
        name={name}
        id={id}
        data-testid={testId ?? id}
        data-input-type="mutiple-select-input-field"
        multiple
        value={selected}
        onChange={handleChange}
        MenuProps={MenuProps as unknown}
        disabled={disabled}
        displayEmpty
        renderValue={
          selected.length && selected.every(Boolean)
            ? renderChips
            : renderPlaceholder
        }
        IconComponent={props => IconSelectCustom(props)}
        inputProps={{ id: `input-${id}` }}
        {...selectProps}
      >
        {enableSearch ? (
          <TextField
            value={SelectValueEnum.SEARCH}
            classes={{ root: classes.textField }}
            InputProps={{
              id: `searchInput-${id}`,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              classes: { notchedOutline: classes.noBorder }
            }}
            placeholder={intl.formatMessage({ defaultMessage: "Search" })}
            className="w-full"
            variant="outlined"
            size="small"
            onKeyDown={e => e.stopPropagation()}
            onChange={onSearch}
            autoFocus
          />
        ) : null}

        {choicesList.length ? (
          <MenuItem
            value={SelectValueEnum.ALL}
            classes={{
              root: isAllSelected ? classes.selectedAll : classes.muiMenuItem
            }}
          >
            {/* <ListItemIcon className={classes.checkboxe}> */}
            <Checkbox
              className={classes.checkbox}
              // className={{ indeterminate: `${classes.indeterminateColor}` }}
              // color="primary"
              checked={isAllSelected}
              indeterminate={
                !disableIndeterminate &&
                selected.length > 0 &&
                selected.length < choicesList.length
              }
            />
            {/* </ListItemIcon> */}
            <ListItemText
              className={listItemClass}
              classes={{ primary: classes.selectAllText }}
              primary={selectAllLabel}
            />
          </MenuItem>
        ) : (
          <MenuItem className={listItemClass}>
            {intl.formatMessage({ defaultMessage: "Not items" })}
          </MenuItem>
        )}

        {choicesList.map(choice => (
          <MenuItem
            key={choice.value}
            value={choice.value}
            classes={{ root: classes.muiMenuItem }}
          >
            {/* <ListItemIcon> */}
            <Checkbox
              className={classes.checkbox}
              checked={selected.includes(choice.value)}
            />
            {/* </ListItemIcon> */}
            {showCircularIcon ? (
              <CircleIcon
                className={classes.circleIcon}
                style={{ color: choice.color }}
              />
            ) : (
              <span className={classes.spacer}></span>
            )}
            <ListItemText className={listItemClass} primary={choice.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default React.memo(OrderStatusCustom);
